import { getCurrentAcademicYear } from "../../../../utils/smallHelpers";
import {SET_FORM_DATA} from "../graduatesOrientationReducer";


const initialState = {
    year: getCurrentAcademicYear(),
    idOrg: "0",
    form: "",
    addschool: "0"
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return action.payload;
        default:
            return state;
    }
};
